import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Translator } from 'angular-translator';

declare const $: any;

/**
 * Define un mensaje
 */
export interface GrowlMessage {
  type: GrowlType;
  body: string;
}

/**
 * Tipos de {@link GrowlMessage}s.
 */
export enum GrowlType {
  DEFAULT,
  INFO,
  DANGER,
  SUCCESS,
  WARNING
}

@Injectable()
export class AlertService {
  constructor(private sxHttp: SxHttpService, private translator: Translator) {}
  
  init() {
    // los errores del server se muestran automaticamente
    this.sxHttp.errors.subscribe(erroresBackend => {
      if(erroresBackend) {
        erroresBackend.forEach(element => {
          this.showGrowl({
            body: element.mensaje,
            type: GrowlType.DANGER
          });
        });
      }
    });
  }

  showSuccessMessage(message: string) {
    this.showGrowl({
      type: GrowlType.SUCCESS,
      body: message,
    });
  }

  /**
   * Muestra un mensaje
   */
  showGrowl(message: GrowlMessage, params: any = null) {
    $.bootstrapGrowl(params != null ? <string>this.translator.instant(message.body, params) : <string>this.translator.instant(message.body), {
      ele:           'app-root',
      position:      'fixed',
      type:          AlertService.convertType(message.type),
      offset:        { from: 'top', amount: 20 },
      align:         'right',
      width:         'auto',
      delay:         4000,
      allow_dismiss: true,
    });
  }

  // tslint:disable-next-line:member-ordering
  private static convertType(type: GrowlType): string {
    switch (type) {
      case GrowlType.WARNING:
        return 'warning';
      case GrowlType.INFO:
        return 'info';
      case GrowlType.DANGER:
        return 'danger';
      case GrowlType.SUCCESS:
        return 'success';
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/alert.service.ts